export default __webpack_public_path__ + "static/lutein_retina_bulb_sm-3cb1554a9c3b76e4b7e429378bc4d142.mp4";